// extracted by mini-css-extract-plugin
export default {"category":"Ym42pV"};